export default __webpack_public_path__ + "static/media/logo_small.ea3a0d6a.svg";